/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * OpenAPI definition
 * OpenAPI spec version: v0
 */
import {
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import * as axios from 'axios';
import type {
  AxiosError,
  AxiosRequestConfig,
  AxiosResponse
} from 'axios';

import type {
  ChatUserIdDto,
  StreamChannelRequest
} from '../../model';





export const updateMemberState = (
    streamChannelRequest: StreamChannelRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.default.post(
      `/api/v1.1/chat/updateMemberState`,
      streamChannelRequest,options
    );
  }



export const getUpdateMemberStateMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateMemberState>>, TError,{data: StreamChannelRequest}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof updateMemberState>>, TError,{data: StreamChannelRequest}, TContext> => {

const mutationKey = ['updateMemberState'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateMemberState>>, {data: StreamChannelRequest}> = (props) => {
          const {data} = props ?? {};

          return  updateMemberState(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateMemberStateMutationResult = NonNullable<Awaited<ReturnType<typeof updateMemberState>>>
    export type UpdateMemberStateMutationBody = StreamChannelRequest
    export type UpdateMemberStateMutationError = AxiosError<unknown>

    export const useUpdateMemberState = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateMemberState>>, TError,{data: StreamChannelRequest}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateMemberState>>,
        TError,
        {data: StreamChannelRequest},
        TContext
      > => {

      const mutationOptions = getUpdateMemberStateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const joinChannel = (
    streamChannelRequest: StreamChannelRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.default.post(
      `/api/v1.1/chat/joinChannel`,
      streamChannelRequest,options
    );
  }



export const getJoinChannelMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof joinChannel>>, TError,{data: StreamChannelRequest}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof joinChannel>>, TError,{data: StreamChannelRequest}, TContext> => {

const mutationKey = ['joinChannel'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof joinChannel>>, {data: StreamChannelRequest}> = (props) => {
          const {data} = props ?? {};

          return  joinChannel(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type JoinChannelMutationResult = NonNullable<Awaited<ReturnType<typeof joinChannel>>>
    export type JoinChannelMutationBody = StreamChannelRequest
    export type JoinChannelMutationError = AxiosError<unknown>

    export const useJoinChannel = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof joinChannel>>, TError,{data: StreamChannelRequest}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof joinChannel>>,
        TError,
        {data: StreamChannelRequest},
        TContext
      > => {

      const mutationOptions = getJoinChannelMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Get the stream user id
 * @deprecated
 * @summary Get the stream user id
 */
export const getChatUserId = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<string>> => {
    
    
    return axios.default.get(
      `/api/v1.1/chat/userId`,{
    ...options,}
    );
  }




export const getGetChatUserIdQueryKey = () => {
    return [
    `/api/v1.1/chat/userId`
    ] as const;
    }

    
export const getGetChatUserIdQueryOptions = <TData = Awaited<ReturnType<typeof getChatUserId>>, TError = AxiosError<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getChatUserId>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetChatUserIdQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getChatUserId>>> = ({ signal }) => getChatUserId({ signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getChatUserId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetChatUserIdQueryResult = NonNullable<Awaited<ReturnType<typeof getChatUserId>>>
export type GetChatUserIdQueryError = AxiosError<unknown>


export function useGetChatUserId<TData = Awaited<ReturnType<typeof getChatUserId>>, TError = AxiosError<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getChatUserId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getChatUserId>>,
          TError,
          Awaited<ReturnType<typeof getChatUserId>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetChatUserId<TData = Awaited<ReturnType<typeof getChatUserId>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getChatUserId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getChatUserId>>,
          TError,
          Awaited<ReturnType<typeof getChatUserId>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetChatUserId<TData = Awaited<ReturnType<typeof getChatUserId>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getChatUserId>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @deprecated
 * @summary Get the stream user id
 */

export function useGetChatUserId<TData = Awaited<ReturnType<typeof getChatUserId>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getChatUserId>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetChatUserIdQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetChatUserIdSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getChatUserId>>, TError = AxiosError<unknown>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getChatUserId>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetChatUserIdQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getChatUserId>>> = ({ signal }) => getChatUserId({ signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getChatUserId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetChatUserIdSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getChatUserId>>>
export type GetChatUserIdSuspenseQueryError = AxiosError<unknown>


export function useGetChatUserIdSuspense<TData = Awaited<ReturnType<typeof getChatUserId>>, TError = AxiosError<unknown>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getChatUserId>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetChatUserIdSuspense<TData = Awaited<ReturnType<typeof getChatUserId>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getChatUserId>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetChatUserIdSuspense<TData = Awaited<ReturnType<typeof getChatUserId>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getChatUserId>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @deprecated
 * @summary Get the stream user id
 */

export function useGetChatUserIdSuspense<TData = Awaited<ReturnType<typeof getChatUserId>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getChatUserId>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetChatUserIdSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Get the stream user id
 * @summary Get the stream user id
 */
export const getChatUserIdV2 = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ChatUserIdDto>> => {
    
    
    return axios.default.get(
      `/api/v1.1/chat/userIdV2`,options
    );
  }




export const getGetChatUserIdV2QueryKey = () => {
    return [
    `/api/v1.1/chat/userIdV2`
    ] as const;
    }

    
export const getGetChatUserIdV2QueryOptions = <TData = Awaited<ReturnType<typeof getChatUserIdV2>>, TError = AxiosError<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getChatUserIdV2>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetChatUserIdV2QueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getChatUserIdV2>>> = ({ signal }) => getChatUserIdV2({ signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getChatUserIdV2>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetChatUserIdV2QueryResult = NonNullable<Awaited<ReturnType<typeof getChatUserIdV2>>>
export type GetChatUserIdV2QueryError = AxiosError<unknown>


export function useGetChatUserIdV2<TData = Awaited<ReturnType<typeof getChatUserIdV2>>, TError = AxiosError<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getChatUserIdV2>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getChatUserIdV2>>,
          TError,
          Awaited<ReturnType<typeof getChatUserIdV2>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetChatUserIdV2<TData = Awaited<ReturnType<typeof getChatUserIdV2>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getChatUserIdV2>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getChatUserIdV2>>,
          TError,
          Awaited<ReturnType<typeof getChatUserIdV2>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetChatUserIdV2<TData = Awaited<ReturnType<typeof getChatUserIdV2>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getChatUserIdV2>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get the stream user id
 */

export function useGetChatUserIdV2<TData = Awaited<ReturnType<typeof getChatUserIdV2>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getChatUserIdV2>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetChatUserIdV2QueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetChatUserIdV2SuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getChatUserIdV2>>, TError = AxiosError<unknown>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getChatUserIdV2>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetChatUserIdV2QueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getChatUserIdV2>>> = ({ signal }) => getChatUserIdV2({ signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getChatUserIdV2>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetChatUserIdV2SuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getChatUserIdV2>>>
export type GetChatUserIdV2SuspenseQueryError = AxiosError<unknown>


export function useGetChatUserIdV2Suspense<TData = Awaited<ReturnType<typeof getChatUserIdV2>>, TError = AxiosError<unknown>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getChatUserIdV2>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetChatUserIdV2Suspense<TData = Awaited<ReturnType<typeof getChatUserIdV2>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getChatUserIdV2>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetChatUserIdV2Suspense<TData = Awaited<ReturnType<typeof getChatUserIdV2>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getChatUserIdV2>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get the stream user id
 */

export function useGetChatUserIdV2Suspense<TData = Awaited<ReturnType<typeof getChatUserIdV2>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getChatUserIdV2>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetChatUserIdV2SuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Get token for streamio chat
 * @summary Get token for streamio chat
 */
export const getToken = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<string>> => {
    
    
    return axios.default.get(
      `/api/v1.1/chat/token`,{
    ...options,}
    );
  }




export const getGetTokenQueryKey = () => {
    return [
    `/api/v1.1/chat/token`
    ] as const;
    }

    
export const getGetTokenQueryOptions = <TData = Awaited<ReturnType<typeof getToken>>, TError = AxiosError<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getToken>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTokenQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getToken>>> = ({ signal }) => getToken({ signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getToken>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTokenQueryResult = NonNullable<Awaited<ReturnType<typeof getToken>>>
export type GetTokenQueryError = AxiosError<unknown>


export function useGetToken<TData = Awaited<ReturnType<typeof getToken>>, TError = AxiosError<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getToken>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getToken>>,
          TError,
          Awaited<ReturnType<typeof getToken>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetToken<TData = Awaited<ReturnType<typeof getToken>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getToken>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getToken>>,
          TError,
          Awaited<ReturnType<typeof getToken>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetToken<TData = Awaited<ReturnType<typeof getToken>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getToken>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get token for streamio chat
 */

export function useGetToken<TData = Awaited<ReturnType<typeof getToken>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getToken>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTokenQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetTokenSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getToken>>, TError = AxiosError<unknown>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getToken>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTokenQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getToken>>> = ({ signal }) => getToken({ signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getToken>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTokenSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getToken>>>
export type GetTokenSuspenseQueryError = AxiosError<unknown>


export function useGetTokenSuspense<TData = Awaited<ReturnType<typeof getToken>>, TError = AxiosError<unknown>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getToken>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTokenSuspense<TData = Awaited<ReturnType<typeof getToken>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getToken>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTokenSuspense<TData = Awaited<ReturnType<typeof getToken>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getToken>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get token for streamio chat
 */

export function useGetTokenSuspense<TData = Awaited<ReturnType<typeof getToken>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getToken>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTokenSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




